import React, { useState } from "react";
import { Link } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import "./ProductCard.css";

function ProductCard({
  item,
  producturl,
  handleProductRoute,
  handleAddToWishList,
  handleAddCart
}) {
  const [isWished, setIsWished] = useState(false);

  if (!item) return null;

  // Formatting price parts (e.g. ₹999.00 -> whole: "999", decimals: "00")
  const formatPriceParts = (price) => {
    if (!price) return { whole: "0", decimals: "00" };
    // Strip trailing symbols/letters
    const cleaned = parseFloat(price.toString().replace(/[^\d.]/g, ""));
    if (isNaN(cleaned)) return { whole: price.toString(), decimals: "00" };
    
    const priceStr = Math.round(cleaned).toString();
    return {
      whole: priceStr,
      decimals: "00"
    };
  };

  const salePrice = item.sale_price || item.price || 0;
  const mrp = item.mrp || null;

  const priceParts = formatPriceParts(salePrice);
  
  // Calculate discount percentage
  const calculateDiscount = () => {
    if (!mrp) return null;
    const saleNum = parseFloat(salePrice.toString().replace(/[^\d.]/g, ""));
    const mrpNum = parseFloat(mrp.toString().replace(/[^\d.]/g, ""));
    
    if (isNaN(saleNum) || isNaN(mrpNum) || mrpNum <= saleNum) return null;
    return Math.round(((mrpNum - saleNum) / mrpNum) * 100);
  };

  const discount = calculateDiscount();

  const handleWishClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsWished(!isWished);
    if (typeof handleAddToWishList === "function") {
      handleAddToWishList(item.product_id);
    }
  };

  const handleCartClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof handleAddCart === "function") {
      handleAddCart(item.product_id);
    }
  };

  const renderStars = (stars) => {
    const count = Math.floor(parseFloat(stars || "4.5"));
    return Array.from({ length: 5 }).map((_, idx) => (
      <StarIcon
        key={idx}
        style={{
          fontSize: "14px",
          color: idx < count ? "#ff9900" : "#e6ede8"
        }}
      />
    ));
  };

  const handleCardRoute = (e) => {
    e.preventDefault();
    if (typeof handleProductRoute === "function") {
      handleProductRoute(item.product_slug);
    }
  };

  return (
    <div className="amazon-product-card" onClick={handleCardRoute}>
      
      {/* 1. Image Container Block */}
      <div className="amazon-card-img-wrap">
        <Link to={`/product/${item.product_slug}`} onClick={handleCardRoute}>
          <img 
            src={item.thumbnail ? (producturl + item.thumbnail) : "placeholder.png"} 
            alt={item.product_name} 
            loading="eager" 
          />
        </Link>
        
        {/* Discount Badge */}
        {discount && discount > 0 && (
          <span className="amazon-card-discount-badge">-{discount}%</span>
        )}

        {/* Wishlist Heart Icon */}
        <button 
          className="amazon-card-wishlist-btn" 
          onClick={handleWishClick}
          aria-label="Add to wishlist"
        >
          {isWished ? (
            <FavoriteIcon style={{ color: "#db0f0f" }} />
          ) : (
            <FavoriteBorderIcon style={{ color: "#8c9c92" }} />
          )}
        </button>
      </div>

      {/* 2. Card Content Body */}
      <div className="amazon-card-body">
        <span className="amazon-card-vendor">{item.vendor_name || "Kerala Special"}</span>
        <Link 
          to={`/product/${item.product_slug}`} 
          className="amazon-card-title" 
          title={item.product_name}
          onClick={handleCardRoute}
        >
          {item.product_name}
        </Link>

        {/* Star Rating Grid */}
        <div className="amazon-card-rating-wrap">
          <div className="amazon-card-stars">
            {renderStars(item.average_stars)}
          </div>
          <span className="amazon-card-rating-count">
            {item.ratings_count || "1,240"}
          </span>
        </div>

        {/* Price Tag Row */}
        <div className="amazon-card-price-row">
          <div className="amazon-card-price-main">
            {discount && discount > 0 && (
              <span className="amazon-card-percentage">-{discount}%</span>
            )}
            <div className="amazon-card-price-tag">
              <span className="amazon-card-price-symbol">₹</span>
              {priceParts.whole}
              <span className="amazon-card-price-decimals">{priceParts.decimals}</span>
            </div>
          </div>
          
          {mrp && (
            <p className="amazon-card-mrp">
              M.R.P.: <span className="amazon-card-mrp-val">₹{mrp}</span>
            </p>
          )}
        </div>

        {/* Quick Add to Cart button */}
        <button className="amazon-card-action-btn" onClick={handleCartClick}>
          Add to Cart
        </button>
      </div>

    </div>
  );
}

export default ProductCard;
